import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useLoginRedirect } from '../layout/unauthorized/auth/hooks/redirect'

export const RedirectDashboard = ({ children }) => {
  const { pathname } = useLocation()

  const loginRedirect = useLoginRedirect()

  useEffect(() => {
    if (pathname === '' || pathname === '/') {
      loginRedirect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <React.Fragment>
      {children}
    </React.Fragment>
  )
}
